var _a;
import { Queue_System_Audit_Log_Action_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Queue_System_Audit_Log_Action_Type.GroupActivated] = 'Group Activated',
    _a[Queue_System_Audit_Log_Action_Type.GroupCountersReset] = 'Group Counters Reset',
    _a[Queue_System_Audit_Log_Action_Type.GroupCreated] = 'Group Created',
    _a[Queue_System_Audit_Log_Action_Type.GroupDeactivated] = 'Group Deactivated',
    _a[Queue_System_Audit_Log_Action_Type.GroupDestroyed] = 'Group Destroyed',
    _a[Queue_System_Audit_Log_Action_Type.GroupQueuesReranked] = 'Group Queues Reranked',
    _a[Queue_System_Audit_Log_Action_Type.GroupUpdated] = 'Group Updated',
    _a[Queue_System_Audit_Log_Action_Type.GroupUsersAdded] = 'Group Users Added',
    _a[Queue_System_Audit_Log_Action_Type.GroupUsersRemoved] = 'Group Users Removed',
    _a[Queue_System_Audit_Log_Action_Type.QueueActivated] = 'Queue Activated',
    _a[Queue_System_Audit_Log_Action_Type.QueueCountersReset] = 'Queue Counters Reset',
    _a[Queue_System_Audit_Log_Action_Type.QueueCreated] = 'Queue Created',
    _a[Queue_System_Audit_Log_Action_Type.QueueDeactivated] = 'Queue Deactivated',
    _a[Queue_System_Audit_Log_Action_Type.QueueDestroyed] = 'Queue Destroyed',
    _a[Queue_System_Audit_Log_Action_Type.QueueReordered] = 'Queue Reordered',
    _a[Queue_System_Audit_Log_Action_Type.QueueUpdated] = 'Queue Updated',
    _a[Queue_System_Audit_Log_Action_Type.QueueUsersAdded] = 'Queue Users Added',
    _a[Queue_System_Audit_Log_Action_Type.QueueUsersRemoved] = 'Queue Users Removed',
    _a[Queue_System_Audit_Log_Action_Type.TagActivated] = 'Tag Activated',
    _a[Queue_System_Audit_Log_Action_Type.TagAssigned] = 'Tag Assigned',
    _a[Queue_System_Audit_Log_Action_Type.TagCountersReset] = 'Tag Counters Reset',
    _a[Queue_System_Audit_Log_Action_Type.TagCreated] = 'Tag Created',
    _a[Queue_System_Audit_Log_Action_Type.TagDeactivated] = 'Tag Deactivated',
    _a[Queue_System_Audit_Log_Action_Type.TagDestroyed] = 'Tag Destroyed',
    _a[Queue_System_Audit_Log_Action_Type.TagUpdated] = 'Tag Updated',
    _a[Queue_System_Audit_Log_Action_Type.Toggle] = 'Toggle',
    _a);
export var QueueSystemAuditLogActionTypeEnum = {
    name: 'Queue_System_Audit_Log_Action_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
